class Tabs {
    constructor() {
        this.tabButtons = document.querySelectorAll('.tab-button');
        this.tabContents = document.querySelectorAll('.tab-content');
        this.intializedSlider = [];
        this.desktopConfig = {
            cellAlign: 'left',
            contain: true,
            groupCells: 2.8,
            pageDots: false
        };
        this.mobileConfig = {
            cellAlign: 'left',
            contain: true,
            groupCells: '90%',
            pageDots: true
        };
        this.addEventListeners();
        this.showContent(this.tabButtons[0].dataset.tab);
    }

    setupSlider(tabId) {
        if(!this.intializedSlider.includes(tabId)){
            if(window.innerWidth > 768){
                $(`#${tabId}`).flickity(this.desktopConfig);
            } else {
                $(`#${tabId}`).flickity(this.mobileConfig);
            }
            this.intializedSlider.push(tabId);
        }
    }

    addEventListeners() {
        this.tabButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                this.showContent(event.currentTarget.dataset.tab);
                setTimeout(function(){
                    window.dispatchEvent(new Event('resize'));
                },100)
                this.setActiveButton(event.currentTarget);
            });
        });
    }

    showContent(tabId) {
        this.tabContents.forEach(content => {
            content.style.display = content.id === tabId ? 'block' : 'none';
            if(content.id === tabId){
                this.setupSlider(tabId);
            }
        });
    }

    setActiveButton(activeButton) {
        this.tabButtons.forEach(button => {
            button.classList.toggle('active', button === activeButton);
        });
    }
}

// Initialize the Tabs class when the DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
    new Tabs();
});